import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { Box } from '@mui/material';

import { type PaginationType } from '../../../hooks/usePagination';
import useSettings from '../../../hooks/useSettings';

import DesktopPagination from './DesktopPagination';
import TabletPagination from './TabletPagination';
import SmartphonePagination from './SmartphonePagination';

export interface ViewPaginationProps {
	className?: string;
	module: string;
	paginationProps: PaginationType;
	additionalButtons?: any[];
	updateRefresh: () => void;
	isSelecting?: boolean;
	selectedItems?: any[];
	showFilters?: boolean;
	showOrder?: boolean;
	showExportButton?: boolean;
	showBorderTop?: boolean;
	showBorderBottom?: boolean;
}

export type PaginationBaseProps = ViewPaginationProps & {
	visibleFilters: boolean;
	visibleOrderFilters: boolean;
};

export default function ViewPagination({
	className,
	module,
	paginationProps,
	additionalButtons,
	updateRefresh,
	isSelecting,
	selectedItems,
	showFilters = true,
	showOrder = true,
	showExportButton = true,
	showBorderTop,
	showBorderBottom
}: ViewPaginationProps) {
	const { settings } = useSettings(module);

	const { ref, width = 0 } = useResizeDetector({ handleHeight: false });

	const visibleFilters = settings?.filter_types?.some(filterType => filterType.filt_visible);
	const visibleOrderFilters = settings?.filter_types?.some(filterType => filterType.filt_sortable);

	const PaginationLayout = width >= 900 ? DesktopPagination : width >= 500 ? TabletPagination : SmartphonePagination;

	return (
		<Box
			ref={ref}
			sx={theme => ({
				borderTop: showBorderTop ? `1px solid ${theme.palette.divider}` : undefined,
				borderBottom: showBorderBottom ? `1px solid ${theme.palette.divider}` : undefined
			})}
		>
			<PaginationLayout
				className={className}
				module={module}
				paginationProps={paginationProps}
				visibleFilters={visibleFilters}
				visibleOrderFilters={visibleOrderFilters}
				additionalButtons={additionalButtons}
				updateRefresh={updateRefresh}
				isSelecting={isSelecting}
				selectedItems={selectedItems}
				showFilters={showFilters}
				showOrder={showOrder}
				showExportButton={showExportButton}
			/>
		</Box>
	);
}
